import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../api/axiosConfig';
import logo from '../../assets/logo.jpeg'; 
import './Register.css';

const Register = () => {
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await api.post('/register', { nombre, email, password });
      setMessage('Usuario registrado con exito. Redirigiendo a login...');
      setTimeout(() => navigate('/login', { state: { registeredEmail: email } }), 2000);
    } catch (err) {
      setMessage('Error al registrar usuario.');
    }
  };

  return (
    <div className="register-container">
      <div className="register-card">
        
        <div className="logo-container">
          <img src={logo} alt="Estudio Metzger" className="logo-image" />
        </div>

        <h2 className="register-title">Crear Cuenta</h2>
        <p className="register-subtitle">Ingresa tus datos para registrarte en el sistema</p>

        {message && (
          <div className={`alert-message ${message.includes('exito') ? 'alert-success' : 'alert-error'}`}>
            <i className={`bi ${message.includes('exito') ? 'bi-check-circle' : 'bi-exclamation-circle'}`} style={{ marginRight: 8 }}></i>
            {message}
          </div>
        )}

        <form onSubmit={handleRegister}>
          <div className="form-group">
            <label className="form-label">
              <i className="bi bi-person" style={{ marginRight: 6 }}></i>Nombre Completo
            </label>
            <input 
              type="text" 
              className="form-input"
              value={nombre} 
              onChange={e => setNombre(e.target.value)} 
              placeholder="Ej. Juan Perez"
              required 
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <i className="bi bi-envelope" style={{ marginRight: 6 }}></i>Email
            </label>
            <input 
              type="email" 
              className="form-input"
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              placeholder="correo@ejemplo.com"
              required 
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <i className="bi bi-lock" style={{ marginRight: 6 }}></i>Contrasena
            </label>
            <input 
              type="password" 
              className="form-input"
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              placeholder="••••••••"
              required 
            />
          </div>

          <button type="submit" className="submit-btn">
            <i className="bi bi-person-plus" style={{ marginRight: 8 }}></i>Registrarse
          </button>
        </form>

        <div className="login-link-container">
          Ya tienes cuenta? <Link to="/login" className="login-link">Inicia Sesion</Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
